module.exports = __webpack_public_path__ + "static/media/global_logo.2cafdf1d.png";